(function($){
    function footerSlider() {
        $('.slider-footer-sponsor').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }]
        });
    }
    
	/* Document Ready */
	$(document).ready(function() {
        footerSlider();
	});

})(jQuery);